import { SecuredRestService } from "shared";
import { IRoleService, IRole, ItemType, AccessType, UserType } from "../types/role_service_types";


export class RoleService extends SecuredRestService implements IRoleService {
    loadRoleList = (itemType: ItemType,
                    itemId: number,
                    accessType: AccessType,
                    userType: UserType,
                    userId: string): Promise<IRole[]> => {
        return this.get<IRole[]>({
            url: "role",
            request: {itemType, itemId: itemId.toString(), accessType, userType, userId}
        }).then(res => {
            return res;
        });
    };

    addRole = (itemType: ItemType,
               accessType: AccessType,
               userType: UserType,
               itemId: number,
               userId: string,
               userName?: string,
               userNameEn?: string,
    ) => {
        return this.post<number>({
            url: "role/add",
            request: { itemType, accessType, userType, itemId, userId, userName, userNameEn }
        }).then(id => {
            return id;
        });
    };

    deleteRole = (itemType: ItemType,
               itemId: number,
               roleId: number
    ) => {
        return this.post<string>({
            url: "role/delete",
            request: { itemType, roleId, itemId }
        }).then(res => {
            return res;
        });
    };

    downloadRoleMatrix = () => {
        return this.get<Blob>({
            url: "rolematrix",
            responseOptions: {
                responseType: "file"
            }
        }).then(res => {
            return res;
        });
    }

    downloadRoleTree = () => {
        return this.get<Blob>({
            url: "roletree",
            responseOptions: {
                responseType: "file"
            }
        }).then(res => {
            return res;
        });
    }

    uploadRoleMatrix = (fileName: string, file: File) => {
        return this.post<string>({
            url: "rolematrix",
            request: { fileName, file }
        }).then(res => {
            return res;
        });
    }

    uploadRoleTree = (fileName: string, file: File) => {
        return this.post<string>({
            url: "roletree",
            request: { fileName, file }
        }).then(res => {
            return res;
        });
    }
}
